Ajax.Responders.register({
		onLoading: function() {
		document.body.addClassName('loading');
	},
		onComplete: function() {
		document.body.removeClassName('loading');
	}    
});

Shopify.onError = function(error) {
	alert('Error: ' + error.message);
}

Shopify.onCartUpdate = function(cart) {
	$('cart-total').innerHTML = Shopify.formatMoney(cart.total_price);
    $('minicart-quantity').innerHTML = cart.item_count;
    $A($('cart-items').childNodes).each(function(node) {$('cart-items').removeChild(node);});
    if(cart.items.length > 0){
        cart.items.each(function(item){
    		itemDiv           = document.createElement('div');
    		itemDiv.className = 'cart-item';
    		itemDiv.id        = 'item-'+item.variant_id;
    		itemDiv.innerHTML = '<div class=\"cart-item-image\">'+
    			'<a href=\"'+item.url+'\"><img src=\"' + Shopify.resizeImage(item.image, 'thumb') + '\" alt=\"' + item.title + '\" /></a>' +
    			'</div>' +
    			item.quantity + ' x <a href=\"'+item.url+'\">' + item.title.truncate(18) + '</a>' +
    			' <a href=\"/cart/change/'+item.variant_id+'?quantity=0\" onclick=\"Shopify.removeItem(' + item.variant_id + ');return false\">remove</a>';
    		$('cart-items').appendChild(itemDiv);
    	});
    }
}  

Shopify.onItemAdded = function(line_item) { 
	Shopify.getCart(function(cart){
		Shopify.onCartUpdate(cart);
	});
}

var Showroom = {
	onVariantChange: function(select) {
	},
	updatePrice: function(product_id) {
		var field = $('product-quantity-'+product_id);
		$('price-field-'+product_id).innerHTML = Shopify.formatMoney($('price-'+product_id).value * field.value);
	}
}